import { combineEpics } from 'redux-observable';
import { loadStore } from './loadStore';
import { editStore } from './editStore';

export default combineEpics(loadStore, editStore);



// WEBPACK FOOTER //
// ./src/scenes/EditStore/services/epics/index.ts